import React, { createContext, useContext, useState, useEffect } from 'react';
import { TokenManager, AuthAPI } from '../api/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        // 앱 시작 시 저장된 사용자 정보 로드
        const storedUser = TokenManager.getUser();
        if (storedUser && TokenManager.isAuthenticated()) {
            setUser(storedUser);
        }
        setIsLoading(false);

        // 토큰 갱신 실패 시 자동 로그아웃
        const handleAuthCleared = () => {
            setUser(null);
        };

        window.addEventListener('authCleared', handleAuthCleared);

        return () => {
            window.removeEventListener('authCleared', handleAuthCleared);
        };
    }, []);

    const login = async (email, password) => {
        const data = await AuthAPI.login(email, password);
        setUser(data.user);
        return data;
    };

    const logout = async () => {
        await AuthAPI.logout();
        setUser(null);
    };

    const updateUser = (userData) => {
        setUser(userData);
        TokenManager.setUser(userData);
    };

    const value = {
        user,
        isAuthenticated: !!user && TokenManager.isAuthenticated(),
        isLoading,
        login,
        logout,
        updateUser,
    };

    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
}

export default AuthContext;
